import {
  IconPageText,
  IconRocket,
  CustomerLogo,
  GreyGrey70,
  Primary12SemiBold,
  Box
} from '@sequencehq/core-components'
import { getInvoiceDueText } from 'Automations/helpers'
import { CustomerLogoById, getLogoSrc } from 'Customer/index'
import { match } from 'ts-pattern'

export const getWorkflowDescription = (automationExecution: {
  input: Record<string, any> & { triggerType?: string }
}) => {
  try {
    return match(automationExecution.input)
      .with({ triggerType: 'QUOTE_REQUIRES_APPROVAL' }, input => ({
        title: `${input.quoteNumber ?? '[Quote number]'} ${input.quoteTitle ?? '[Quote title]'}`,
        description: (
          <>
            Quote sent for approval by{' '}
            <Box as="span" {...Primary12SemiBold}>
              {input.requestorEmail ?? '[Requestor email]'}
            </Box>
          </>
        ),
        logo: (
          <CustomerLogo
            src={
              automationExecution.input.customerDomain
                ? getLogoSrc({
                    domain: automationExecution.input.customerDomain
                  })
                : undefined
            }
            size={24}
            fallbackSize={16}
          />
        )
      }))
      .with({ triggerType: 'CONTRACT_UPLOADED' }, input => ({
        title: input.fileName
          ? `Contract ${input.fileName} uploaded`
          : 'Contract uploaded',
        description: (
          <>
            Contract sent for approval by{' '}
            <Box as="span" {...Primary12SemiBold}>
              Contract intake agent
            </Box>
          </>
        ),
        logo: <IconPageText color={GreyGrey70} />
      }))
      .with({ triggerType: 'INVOICE_SENT' }, input => ({
        title: getInvoiceDueText({
          invoiceNumber: input.invoiceNumber,
          dueDate: input.dueDate
        }),
        description: 'Payment reminder scheduled',
        logo: (
          <CustomerLogoById
            customerId={input.customerId}
            data-testid="workflow.customerLogo"
          />
        )
      }))
      .otherwise(() => ({
        title: 'Workflow execution',
        description: 'More information coming soon',
        logo: <IconRocket color={GreyGrey70} />
      }))
  } catch {
    return {
      title: 'Workflow execution',
      description: 'More information coming soon',
      logo: <IconRocket color={GreyGrey70} />
    }
  }
}
